import { QueryParams } from '../constants';

type Modes = 'authenticate' | 'logout';

const getDefaultRedirectTo = (
  mode: Modes = 'authenticate',
  locationHostname: string
) => {
  const hostname = locationHostname.includes('localhost') ? 'https://portal.usccadev.com' : locationHostname;
  let redirectTo = `https://www.${hostname.split('.').slice(-2).join('.')}`;
  if (mode === 'authenticate') {
    const isCabelas = hostname.includes('cabela');
    const isStaging = hostname.includes('staging');
    const memberSiteSubdomain = isCabelas ? 'account' : 'my';
    redirectTo = redirectTo.replace('www', `${isStaging ? 'staging.' : ''}${memberSiteSubdomain}`);
  }
  return redirectTo;
};

export const getRedirectTo = (
  mode: Modes = 'authenticate',
  locationHostname = location.hostname
) => {
  try {
    const params = new URLSearchParams(location.search);
    const redirectToParam = params.get(QueryParams.RedirectTo) || params.get(QueryParams.RedirectToAlt) || '';
    const redirectHostname = new URL(redirectToParam).hostname;
    if ([
      '.deltadefense.com',
      '.deltadefensedev.com',
      '.usconcealedcarry.com',
      '.usccadev.com',
      '.cabelas-shield.com'
    ].some(e => redirectHostname.endsWith(e))) {
      return redirectToParam;
    }

    return getDefaultRedirectTo(mode, locationHostname);
  } catch {
    return getDefaultRedirectTo(mode, locationHostname);
  }
};
